<template>
</template>

<script>
import { mapState } from 'vuex';
import { ensureGtmLoaded, pushEcommerceEvent, saveItemSource } from 'assets/js/gtm';

export default {
    name: "PT508GTMViewListItem",
    data() {
        return {
            eventSent: false,
            listItem110: [],
            listItem310: [],
            listItem320: [],
            listItem510: [],
            queryData: {}
        };
    },
    computed: {
        ...mapState('pt110', ['pt110Init']),
        ...mapState('pt120', ['pt120Init']),
        ...mapState('pt125', ['pt125Init']),
        ...mapState('pt310', ['pt310Init']),
        ...mapState('pt320', ['pt320Init']),
        ...mapState('pt180', ['pt180Init']),
        ...mapState('pt510', ['pt510Init']),
        navList() {
            return this.pt110Init && Array.isArray(this.pt110Init.navList) ? this.pt110Init.navList : [];
        },
        productList() {
            return this.pt110Init && Array.isArray(this.pt110Init.productList) ? this.pt110Init.productList : [];
        },
        relationList310() {
            return this.pt310Init && Array.isArray(this.pt310Init.relationList) ? this.pt310Init.relationList : [];
        },
        relationList320() {
            return this.pt320Init && Array.isArray(this.pt320Init.relationList) ? this.pt320Init.relationList : [];
        },
        relationList510() {
            return this.pt510Init && Array.isArray(this.pt510Init.relationList) ? this.pt510Init.relationList : [];
        },
        gtmContainerId() {
            return this.pt110Init?.gtmcontainerId
                || this.pt180Init?.gtmcontainerId
                || this.pt120Init?.gtmcontainerId
                || this.pt125Init?.gtmcontainerId
                || '';
        },
        eventPayloadReady() {
            return !!this.gtmContainerId
        }
    },
    watch: {
        eventPayloadReady: {
            handler(ready) {
                if (ready) {
                    this.$nextTick(() => {
                        this.initAndPushViewItem();
                    })
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.$nextTick(() => {
            $(document).on('click', '.sliderProduct', this.selectItem)
            $(document).on('click', '#pt110 .itemList li', this.selectItem);
            this.queryData = this.$route.query
        });
    },

    destroyed() {
        $(document).off('click', '.sliderProduct', this.selectItem);
        $(document).off('click', '#pt110 .itemList li', this.selectItem);
    },
    methods: {
        hasDetailComponentRoot() {
            return !!document.querySelector('#pt110') || !!document.querySelector('#pt510') || !!document.querySelector('#pt310') || !!document.querySelector('#pt320');
        },
        canRunInContext() {
            return this.hasDetailComponentRoot();
        },
        initAndPushViewItem() {
            if (!this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            this.$store.commit('setGtmId', this.gtmContainerId);
            ensureGtmLoaded();
            setTimeout(() => {
                this.pushViewItem();
            }, 200);
        },
        pushViewItem() {
            if (!this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            if (!!document.querySelector('#pt110')) {
                const list = this.navList?.at(-1) || []
                var listId = list.CATEGORY_CD;
                var listName = list.CATEGORY_NM;
                const item = this.productList.map((productListItem, index) => {
                    return {
                        item_id: productListItem.S_ITEM_CD,
                        item_name: productListItem.WEB_ITEM_NM,
                        item_list_id: listId,
                        item_list_name: listName,
                        index,

                    }
                })
                this.listItem110 = item
                pushEcommerceEvent('view_item_list', {
                    currency: 'JPY',
                    item_list_id: listId,
                    item_list_name: listName,
                    items: [
                        ...item
                    ],
                });
            }
            if (!!document.querySelector('#pt310')) {
                var listId = "PT310";
                var listName = "この商品を買った人はこんな商品も買っています";
                const item = this.relationList310.map((productListItem, index) => {
                    return {
                        item_id: productListItem.S_ITEM_NO,
                        item_name: productListItem.WEB_ITEM_NM,
                        index,

                    }
                })
                this.listItem310 = item
                pushEcommerceEvent('view_item_list', {
                    currency: 'JPY',
                    item_list_id: listId,
                    item_list_name: listName,
                    items: [
                        ...item
                    ],
                });

            }
            if (!!document.querySelector('#pt320')) {
                var listId = "PT320";
                var listName = "最近チェックした商品";
                const item = this.relationList320.map((productListItem, index) => {
                    return {
                        item_id: productListItem.S_ITEM_NO,
                        item_name: productListItem.WEB_ITEM_NM,
                        index,

                    }
                })
                this.listItem320 = item
                pushEcommerceEvent('view_item_list', {
                    currency: 'JPY',
                    item_list_id: listId,
                    item_list_name: listName,
                    items: [
                        ...item
                    ],
                });
            }
            if (!!document.querySelector('#pt510')) {
                var listId = "PT510";
                var listName = "最近購入した商品";
                const item = this.relationList510.map((productListItem, index) => {
                    return {
                        item_id: productListItem.S_ITEM_NO,
                        item_name: productListItem.WEB_ITEM_NM,
                        index,

                    }
                })
                this.listItem510 = item
                pushEcommerceEvent('view_item_list', {
                    currency: 'JPY',
                    item_list_id: listId,
                    item_list_name: listName,
                    items: [
                        ...item
                    ],
                });
            }
        },
        selectItem(e) {
            const $dom = $(e.currentTarget)
            if ($dom.parents('#pt110').length) {
                const { ptPageNo, ptPageSize } = this.queryData
                const index = $dom.index();
                const list = this.navList?.at(-1) || []
                var listId = list.CATEGORY_CD;
                var listName = list.CATEGORY_NM;
                const item = this.listItem110.length && this.listItem110[index]
                saveItemSource({
                    item_id: item.item_id,
                    item_list_id: listId,
                    item_list_name: listName,
                    index: item.index + Number(ptPageNo || 0) * Number(ptPageSize || 0),
                    source_event: "select_item"
                });
            }
            if ($dom.parents('#pt310').length) {
                var listId = "PT310";
                var listName = "この商品を買った人はこんな商品も買っています";
                const index = $dom.index();
                const item = this.listItem310.length && this.listItem310[index]
                saveItemSource({
                    item_id: item.item_id,
                    item_list_id: listId,
                    item_list_name: listName,
                    index: item.index,
                    source_event: "select_item"
                });

            }
            if ($dom.parents('#pt320').length) {
                var listId = "PT320";
                var listName = "最近チェックした商品";
                const index = $dom.index();
                const item = this.listItem320.length && this.listItem320[index]
                saveItemSource({
                    item_id: item.item_id,
                    item_list_id: listId,
                    item_list_name: listName,
                    index: item.index,
                    source_event: "select_item"
                });

            }
            if ($dom.parents('#pt510').length) {
                var listId = "PT510";
                var listName = "最近購入した商品";
                const index = $dom.index();
                const item = this.listItem510.length && this.listItem510[index]
                saveItemSource({
                    item_id: item.item_id,
                    item_list_id: listId,
                    item_list_name: listName,
                    index: item.index,
                    source_event: "select_item"
                });

            }
        }
    }
}
</script>
